import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ReviewCard from "./ReviewCard";

const reviewsList = [
  {
    imageSrc: "review-eugenia.png",
    name: "Евгения Екимовская",
    subtitle: "ООО «Фридман Тревел»",
    description:
      "«За три недели узнала современные тенденции и обновила знания по направлениям. Получила ценные контакт представителей туробъектов, а также фото, видео и каталоги необходимые для работы. Во время интенсива и сразу после него делала продажи, используя свеженькую информацию, которую узнала во время обучения. Познакомилась с крутыми спикерами спецэфиров и даже начала обучение у одного из них. Подписалась на экспертов по продвижению и продолжаю черпать полезные знания из их блогов. Ещё я выиграла три дня на Мальдивах — планирую поездку в декабре! Была рада присутствовать на выставке, с удовольствием буду участвовать в следующей»",
  },
  {
    imageSrc: "review-irina.png",
    name: "Ирина Петрова",
    subtitle: "генеральный директор IMP Travel.",
    description:
      "«Очень много полезной информации! Грамотные спикеры! Супер удобно обучаться по 30 минут и в первой половине дня! Скачала множество отличных каталогов и презентаций, активно использую их в работе! С момента участия в интенсиве прошло время, и я уже успела внедрить несколько идей от спикеров и заключить несколько новых договоров с партнёрами, что значительно улучшило мои продажи! Рекомендую выставку OTM коллегам как источник практических знаний и инструмент для масштабирования бизнеса»!",
  },
];

const Reviews: React.FC = () => {
  const location = useLocation();
  const ref = useRef(null);
  const workshopTitle: string = useSelector(
    (state: any) => state.Main.Workshop.data.title
  );

  useEffect(() => {
    const anchor = new URLSearchParams(location.search).get("anchor");
    if (anchor === "reviews-anchor" && ref) {
      console.log("SCROLL EVENT");
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location, ref]);

  return (
    <section
      className="bg-dark-gray-500 py-[54px] md:py-16 lg:py-[100px] 2xl:py-[120px] 3xl:py-[140px]"
      id="reviews-anchor"
      ref={ref}
    >
      <div className="cont">
        <div className="text-white flex flex-col gap-8 lg:flex-row lg:gap-[58px] justify-between">
          <p className="title-middle max-w-[430px] xl:max-w-full no-wrap">
            Отзывы
          </p>
          {/* <div className="flex flex-col gap-4 lg:text-18 max-w-[456px] xl:max-w-[544px] 2xl:max-w-[624px] 3xl:max-w-[704px] 4xl:max-w-[743px]">
            <p>
              В августе 2024 года команда Profi.Travel провела интенсив по
              продаже зарубежного турпродукта в рамках выставки{" "}
              <a
                className="text-red-500 hover:underline"
                href="https://otm-winter-2024.profi.travel/"
                target="_blank"
              >
                ОТМ: Winter 24/25.
              </a>
            </p>
            <p>
              За три недели участники прослушали более 60 онлайн-презентаций,
              специэфиров, мастер-классов. В итоговом опросе они поделились
              положительными отзывами о мероприятии.
            </p>
          </div> */}
        </div>
        <div className="reviews__list">
          {reviewsList.map((item, index) => (
            <ReviewCard
              key={index}
              imageSrc={item.imageSrc}
              name={item.name}
              subtitle={item.subtitle}
              description={item.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
